import React from 'react';

import { Typography } from '../typography/typography';
import SvgArrowRight from '../icons/ArrowRight';
import SvgArrowLeft from '../icons/ArrowLeft';
import { Button } from '../button/button';

interface DataTableProps extends React.HTMLAttributes<HTMLDivElement> {
  prevPageDisabled: boolean;
  nextPageDisabled: boolean;
  hideOnNoItems?: boolean;
  nextPage: () => void;
  prevPage: () => void;
  totalRows: number;
  pageIndex: number;
  pageSize: number;
}

export const DataTablePagination = ({
  hideOnNoItems = true,
  prevPageDisabled,
  nextPageDisabled,
  pageIndex,
  totalRows,
  nextPage,
  prevPage,
  pageSize,
  ...props
}: DataTableProps) => {
  if (hideOnNoItems && totalRows === 0) {
    return null;
  }

  return (
    <div className="flex gap-2 justify-end items-center w-44" {...props}>
      <Typography className="text-weak whitespace-nowrap mr-2" variant="labelMediumBook">
        {pageIndex * pageSize + 1}-{Math.min((pageIndex + 1) * pageSize, totalRows ?? 0)} /{' '}
        {totalRows ?? 0}
      </Typography>
      <Button
        disabled={prevPageDisabled}
        onClick={prevPage}
        variant="ghost"
        type="button"
        size="small"
      >
        <SvgArrowLeft height={16} width={16} />
      </Button>
      <Button
        disabled={nextPageDisabled}
        onClick={nextPage}
        variant="ghost"
        type="button"
        size="small"
      >
        <SvgArrowRight height={16} width={16} />
      </Button>
    </div>
  );
};
